import { render } from "./DisciplineModal.vue?vue&type=template&id=53a31cbe&scoped=true"
import script from "./DisciplineModal.vue?vue&type=script&lang=js"
export * from "./DisciplineModal.vue?vue&type=script&lang=js"

import "./DisciplineModal.vue?vue&type=style&index=0&id=53a31cbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a31cbe"]])

export default __exports__